import * as authenticationDuck from 'store/ducks/authentication'

// Reducer

export type SecurityState = {
  admin: boolean
  type: string
  status: string
}

const INITIAL_STATE: SecurityState = {
  admin: false,
  type: null,
  status: null,
}

export function reducer(state: SecurityState = INITIAL_STATE, action) {
  switch (action.type) {
    case authenticationDuck.LOGIN_SUCCESS:
    case authenticationDuck.REFRESH_TOKEN_SUCCESS:
      const roles = (action && action.payload && action.payload.roles) || []
      const type = (action && action.payload && action.payload.type) || null
      const status = (action && action.payload && action.payload.status) || null

      return {
        ...state,
        admin: roles.includes('ROLE_ADMIN'),
        type: type,
        status: status,
      }

    case authenticationDuck.LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      }
    default:
      return state
  }
}
